import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import MeetingHeroImg from '../../asset/MeetingHeroImg.webp'
import Check from '../../asset/Check.svg'
import { Button } from '../ui/button';
import { BookingForm } from '../ui/BookingForm';

export const HeroMeeting = () => {
    const location = useLocation();

    const scrollToBookATour = () => {
        const element = document.getElementById('book-a-tour');
        if (element) {
            const headerHeight = 105;
            const elementPosition = element.offsetTop - headerHeight;

            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <section style={{
            backgroundImage: window.innerWidth >= 768 ? `url(${MeetingHeroImg})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#fef4ea',
            width: '100vw',
            height: window.innerWidth >= 768 ? 'calc(100vh - 65px)' : 'auto',
        }}
            className="w-full mt-[55px] sm:mt-[65px] relative flex items-center justify-center sm:justify-start bg-white pt-[60px] sm:pt-[100px] pb-[30px] sm:pb-[50px] px-4 sm:px-8 lg:px-[65px] max-md:flex-col max-md:h-auto max-md:gap-6 sm:max-md:gap-10">
            <div className="w-full sm:w-[55%] h-full flex sm:block sm:h-auto flex-col justify-evenly text-center sm:text-left max-w-[700px] relative">
                <div className="relative mb-4">
                    <h1 className="text-4xl sm:text-7xl font-bold leading-tight sm:leading-[85px]  font-regrade">
                        <span className="text-[#262626]">On-Demand </span> <br />
                        <span className="text-[#74344e]">Meeting Rooms </span> <br />

                        <span className='flex justify-center sm:justify-start mt-10'><img src={Check} className='w-[30px] h-[30px] mr-4' />
                            <span className="text-[#262626] text-3xl font-sans font-[600]">Fully Equipped</span>
                        </span>

                        <span className='flex justify-center sm:justify-start mt-8'><img src={Check} className='w-[30px] h-[30px] mr-4' />
                            <span className="text-[#262626] text-3xl font-sans font-[600]">Prime Location</span>
                        </span>

                        <p style={{
                            background: 'linear-gradient(to right, #c33637, #c33637, transparent)',
                            borderRadius: '10px'
                        }} className="text-[white] mx-auto sm:mx-0 mt-10 text-base pl-6 py-3 pr-16  sm:text-2xl font-semibold leading-[24px] sm:leading-[32.4px] mb-4 max-w-fit ">
                            Book <span className='text-[#e8bd69]'>•</span> Meet <span className='text-[#e8bd69]'>•</span> Make It Count
                        </p>

                        <button
                            onClick={scrollToBookATour}
                            style={{ border: '1px solid white' }}
                            className=" text-white mt-8 text-base px-2 py-3 text-xl font-sans mb-4 px-8 bg-gradient-to-r from-[#75354f] to-[#222021] text-black font-medium rounded-full transition-all duration-200" >
                            Book Now
                        </button>
                    </h1>
                </div>
            </div>
            <div className="w-full sm:w-[45%] mt-10 sm:mt-0">
                <BookingForm />
            </div>
        </section>
    );
};
